import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

// Shown while a lazily-loaded route chunk is fetched. Mimics a typical page
// (title + cards) so navigation feels instant instead of a blank/spinner wait.
export default function RouteFallback() {
  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto w-full" data-testid="route-fallback">
      <Skeleton className="h-8 w-48 mb-2" />
      <Skeleton className="h-4 w-72 mb-6" />
      <div className="grid gap-4 sm:grid-cols-2">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="rounded-xl border border-line p-4 bg-surface-2">
            <Skeleton className="h-32 w-full mb-3 rounded-lg" />
            <Skeleton className="h-4 w-3/4 mb-2" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        ))}
      </div>
    </div>
  );
}
